import NavResponsiveModal, { ModalActions, ModalHeader } from '@/components/Navigation/NavResponsiveModal';
import { PrimaryButton, SecondaryButton } from '@/styles/blocks';

const DeleteSKUModal = ({ open, onCancel, onConfirm, loading }) => (
    <NavResponsiveModal open={open} onClose={onCancel} maxWidth="xs" fullWidth>
        <ModalHeader title="Are you sure you want to delete this SKU?" onClose={onCancel} />
        <ModalActions>
            <SecondaryButton onClick={onCancel}>Cancel</SecondaryButton>
            <PrimaryButton red disabled={loading} loading={loading} onClick={onConfirm}>
                Yes
            </PrimaryButton>
        </ModalActions>
    </NavResponsiveModal>
);

export default DeleteSKUModal;
